const getDispatchData = () => {
  if (typeof window !== 'undefined' && localStorage) {
    const strDispatch = localStorage.getItem('DispatchData');
    if (!strDispatch) {
      return null;
    }
    return JSON.parse(strDispatch);
  }
  return null;
};

const updateDispatchDataByParam = (params) => {
  if (typeof window !== 'undefined' && localStorage) {
    const dispatchData = getDispatchData();
    if (dispatchData !== null) {
      const param = {
        ...dispatchData,
        ...params,
      };
      localStorage.setItem('DispatchData', JSON.stringify(param));
    } else {
      initDispatchData(params);
    }
  }
};

const updateDispatchData = (key, value) => {
  if (typeof window !== 'undefined' && localStorage) {
    const dispatchData = getDispatchData();
    if (dispatchData !== null) {
      const param = {
        ...dispatchData,
        [key]: value,
      };
      localStorage.setItem('DispatchData', JSON.stringify(param));
    } else {
      const param = {
        [key]: value,
      };
      initDispatchData(param);
    }
  }
};

const initDispatchData = (param) => {
  if (typeof window !== 'undefined' && localStorage) {
    localStorage.setItem('DispatchData', JSON.stringify(param));
  }
};

const clearDispatchData = () => {
  if (typeof window !== 'undefined' && localStorage) {
    localStorage.removeItem('DispatchData');
  }
};

export {
  getDispatchData,
  updateDispatchData,
  initDispatchData,
  clearDispatchData,
  updateDispatchDataByParam,
};
